import {objectsEqual} from "./ObjectUtils.js";

/**
 * Returns true if the two arrays are equal.
 *
 * @param a1
 * @param a2
 * @return {boolean}
 */
export function arraysEqual(a1, a2) {
	return a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));
}

/**
 * Change function that returns true if `value` is different from `oldValue`.
 * This method is used as the default for a property's `hasChanged` function.
 */
export function arrayNotEqual(value, oldValue) {
	if(Array.isArray(value) && Array.isArray(oldValue)) {
		return !arraysEqual(value, oldValue);
	} else
		return true;
}